import React, { Component } from 'react'
import { connect } from 'dva'
import 'core-js/features/map'
import 'core-js/features/set'
import LazyLoad from 'react-lazyload'
import styles from './moduleList.module.less'
import Module from './Module'
import FixedBar from '../components/FixedBar'
import classNames from 'classnames'
import Utils from '../common/lib/utils'
import 'core-js/es/map'
import 'core-js/es/set'
import '../lib/AplusExt'

const adParam = {
  p: '', // 广告id
  sid: '', // pvid
  s: '', // showid
  aw: 'w',
  k: '', // showid_en
  rst: 'h5,img'
}
const adIdsConfig = ',26,52,60,62,101486,163,164,165,167,168,169,171,262,263,267,271,272,279,358,363,364,373,380,386,387,391,402,412,416,419,427,431,432,480,481,482,489,490,584,588,589,607,608,612,613,712,713,761,762,798,799,800,801,802,803,804,805,806,807,808,809,810,812,813,815,816,864,'
class ModuleList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isClientRender: false
    }
    this.isChecked = false
    const _ramdom = Math.random() * 100
    this.isNewAd = false
    if (__isBrowser__) {
      const _isFocusad = Utils.getUrlParam()['isFocusNewad']
      if (_isFocusad === '1' || _isFocusad === '0') {
        this.isNewAd = _isFocusad === '1'
      } else {
        this.isNewAd = window.isRequest && (window.adPercent && _ramdom < window.adPercent)
      }
      console.log(`this.isNewAd::${this.isNewAd}|| _isFocusad::${_isFocusad}`)
    }
  }
  // 统一请求广告
  requestAD (adList) {
    if (!adList || adList.length < 1) {
      return
    }
    let _idStr = ''
    adList.map((adData) => {
      if (adIdsConfig.indexOf(`,${adData.adId},`) > -1) {
        _idStr += `${adData.adId},`
      }
    })
    if (!_idStr) {
      return
    }
    const userAgent = navigator.userAgent.toLowerCase()
    const param = adParam
    param.p = _idStr
    param.ios = (userAgent.indexOf('mac') !== -1 || userAgent.indexOf('ios') !== -1)
    param.compatible = 1
    // 将mac也包含进IOS系统中
    Utils.getScript('//html.atm.youku.com/html?' + Utils.paramToUrl(param), { charset: 'gbk' })
  }

  componentDidMount () {
    this.setState({ isClientRender: true })

    if (__isBrowser__ && !this.props.hasPcFocus) {
      setTimeout(() => { window.Header && window.Header.changeState(true) }, 50)
    }

    if (!this.isNewAd) {
      this.requestAD(this.props.adList)
    }
  }

  render () {
    const _class = this.props.hasPcFocus ? styles.s_body : classNames(styles.s_body, styles.body_top110)
    return (
      <div className={_class}>
        <FixedBar />
        {
          this.props.serverData.map((module, index) => {
            const _forceRender = index <= this.props.pcBannerIndex + 5
            return <Module data={module} forceRender={_forceRender} key={`s${index}`} />
          })
        }
        {
          this.state.isClientRender ? this.props.clientData.map((module, index) => {
            return <LazyLoad key={`module${index}`} height={400} offset={0} once><Module data={module} key={`c${index}`} /></LazyLoad>
          }) : ''
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const topDatas = []
  const commonDatas = []
  let topCatFlag = false
  let hasTopNav = false
  let pcBannerIndex = -1
  let adIds = []
  state.moduleList.data.map((item, index) => {
    if (!topCatFlag) {
      topDatas.push(item)
    } else {
      commonDatas.push(item)
    }
    if (!topCatFlag && item.type === 'PC_BANNER') {
      topCatFlag = true
      pcBannerIndex = index
    }
    if (!hasTopNav && (item.type === 'WEB_NAV_SEC' || item.type === 'PC_NAV')) {
      hasTopNav = true
    }
    if (item.type === 'PC_ADS') {
      adIds.push({ adId: item.adId, adType: item.adType })
    }

    if (pcBannerIndex === -1 && item.type === 'PC_HTML') {
      item.isLayoutHori = true
      item.isHiddenHeader = true
      item.isIgnoreBottom = true
    }
  })
  if (topCatFlag && !hasTopNav) {
    // 如果有轮播图 但是没有导航，给轮播图组件设置bottom为40
    state.moduleList.data[pcBannerIndex].bottom = 40
  }
  const serverDataIndex = pcBannerIndex + 5
  return {
    // sdata: state.moduleList.data,
    serverData: state.moduleList.data.slice(0, serverDataIndex),
    clientData: state.moduleList.data.length > serverDataIndex ? state.moduleList.data.slice(serverDataIndex, state.moduleList.data.length) : [],
    hasPcFocus: topCatFlag, // 是否有头部轮播图
    topModules: topDatas,
    adList: adIds,
    commonModules: commonDatas,
    pcBannerIndex: pcBannerIndex
  }
}

export default connect(mapStateToProps)(ModuleList)
